import remark  from 'remark'
import remarkHTML from 'remark-html'

export const parseMarkdownAsHTML = markdown => {
    return remark()
        .use(remarkHTML)
        .processSync(markdown)
        .toString()
}